import React from 'react';

interface HeaderProps {
  onLoginClick: () => void;
  onRegisterClick?: () => void;
  onNavigate?: (id: string) => void;
  activePage?: string;
}

const Header: React.FC<HeaderProps> = ({ onLoginClick, onRegisterClick, onNavigate, activePage }) => {
  return (
    <header className="bg-tipico-red text-white px-6 h-[64px] flex justify-between items-center sticky top-0 z-50 shadow-md">
      <div className="flex items-center gap-10">
        <div className="text-[28px] font-black tracking-tighter cursor-pointer" onClick={() => onNavigate?.('home')}>TIPICO</div>
        <nav className="hidden md:flex gap-8 font-black text-[13px] uppercase tracking-wider h-full">
          <button
            onClick={() => onNavigate?.('home')}
            className={`h-[64px] border-b-4 transition-all ${
              activePage === 'home' || !activePage ? 'border-white opacity-100' : 'border-transparent opacity-70 hover:opacity-100'
            }`}
          >
            Sportwetten
          </button>
          <button
            onClick={() => onNavigate?.('live')}
            className={`h-[64px] border-b-4 transition-all ${
              activePage === 'live' ? 'border-white opacity-100' : 'border-transparent opacity-70 hover:opacity-100'
            }`}
          >
            Livewetten
          </button>
          <button className="h-[64px] border-b-4 border-transparent opacity-70 hover:opacity-100 transition-all">
            Casino
          </button>
        </nav>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={onLoginClick}
          className="text-white font-black px-3 py-1 md:px-5 md:py-2 rounded-full text-[11px] md:text-[13px] hover:bg-tipico-red-dark transition uppercase tracking-wide"
        >
          Einloggen
        </button>
        <button
          onClick={onRegisterClick}
          className="hidden md:block bg-white text-tipico-red font-black px-3 py-1 md:px-6 md:py-2 rounded-full text-[11px] md:text-[13px] hover:bg-gray-100 transition shadow-sm uppercase tracking-wide"
        >
          Registrieren
        </button>
      </div>
    </header>
  );
};

export default Header;
